/** @format */

const getRedirectionLink = item => {
  if (!item) return '/404';

  if (item.nid) {
    return item.public ? `/page/public/${item.nid}` : `/page/${item.nid}`;
  }

  return item.link || '/404';
};

export const getKnowledgeBaseLink = (kb, item) => {
  if (!item || !kb) return '/404';

  if (item.nid) {
    return item.public
      ? `/knowledge-base/${kb}/article/public/${item.nid}`
      : `/knowledge-base/${kb}/article/${item.nid}`;
  }

  return item.link || '/404';
};

export const getNewsLink = item => {
  if (!item) return '/404';

  if (item.nid) {
    return item.public ? `/news/public/${item.nid}` : `/news/${item.nid}`;
  }

  return item.link || '/404';
};

export const getFileBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Str = reader.result;
      resolve(base64Str.split(';base64,').length > 1 ? base64Str.split(';base64,')[1] : null);
    };
    reader.onerror = reject;
  });
};

export const fixSalutationValues = {
  mr: 'mr',
  mrs: 'mrs',
  Frau: 'mrs',
  Herr: 'mr',
  Monsieur: 'mr',
  other: 'others'
};

export default getRedirectionLink;
